/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Viewoptions_View1Inputs */

const id_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat`)
};

const ms_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat`)
};

const da_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis`)
};

const de_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht`)
};

const en_us2_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const es_es2_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const es_mx2_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const fil_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan`)
};

const fr_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage`)
};

const it_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista`)
};

const hu_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nézet`)
};

const nl_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weergave`)
};

const no_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis`)
};

const pl_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widok`)
};

const pt_br2_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const pt_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const ro_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizualizare`)
};

const fi_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä`)
};

const sv_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa`)
};

const vi_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem`)
};

const tr_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görünüm`)
};

const cs_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazení`)
};

const bg_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изглед`)
};

const ru_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вид`)
};

const uk_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вид`)
};

const ar_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض`)
};

const hi_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दृश्य`)
};

const th_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มุมมอง`)
};

const ja_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示`)
};

const zh_cn2_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const zh_hant1_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const ko_table_viewoptions_view1 = /** @type {(inputs: Table_Viewoptions_View1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Table_Viewoptions_View1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_viewoptions_view1 = /** @type {((inputs?: Table_Viewoptions_View1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Viewoptions_View1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_viewoptions_view1(inputs)
	if (locale === "ms") return ms_table_viewoptions_view1(inputs)
	if (locale === "da") return da_table_viewoptions_view1(inputs)
	if (locale === "de") return de_table_viewoptions_view1(inputs)
	if (locale === "en-US") return en_us2_table_viewoptions_view1(inputs)
	if (locale === "es-ES") return es_es2_table_viewoptions_view1(inputs)
	if (locale === "es-MX") return es_mx2_table_viewoptions_view1(inputs)
	if (locale === "fil") return fil_table_viewoptions_view1(inputs)
	if (locale === "fr") return fr_table_viewoptions_view1(inputs)
	if (locale === "it") return it_table_viewoptions_view1(inputs)
	if (locale === "hu") return hu_table_viewoptions_view1(inputs)
	if (locale === "nl") return nl_table_viewoptions_view1(inputs)
	if (locale === "no") return no_table_viewoptions_view1(inputs)
	if (locale === "pl") return pl_table_viewoptions_view1(inputs)
	if (locale === "pt-BR") return pt_br2_table_viewoptions_view1(inputs)
	if (locale === "pt") return pt_table_viewoptions_view1(inputs)
	if (locale === "ro") return ro_table_viewoptions_view1(inputs)
	if (locale === "fi") return fi_table_viewoptions_view1(inputs)
	if (locale === "sv") return sv_table_viewoptions_view1(inputs)
	if (locale === "vi") return vi_table_viewoptions_view1(inputs)
	if (locale === "tr") return tr_table_viewoptions_view1(inputs)
	if (locale === "cs") return cs_table_viewoptions_view1(inputs)
	if (locale === "bg") return bg_table_viewoptions_view1(inputs)
	if (locale === "ru") return ru_table_viewoptions_view1(inputs)
	if (locale === "uk") return uk_table_viewoptions_view1(inputs)
	if (locale === "ar") return ar_table_viewoptions_view1(inputs)
	if (locale === "hi") return hi_table_viewoptions_view1(inputs)
	if (locale === "th") return th_table_viewoptions_view1(inputs)
	if (locale === "ja") return ja_table_viewoptions_view1(inputs)
	if (locale === "zh-CN") return zh_cn2_table_viewoptions_view1(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_viewoptions_view1(inputs)
	return ko_table_viewoptions_view1(inputs)
});
export { table_viewoptions_view1 as "table.viewOptions.view" }